import {Link, Typography} from "@material-ui/core";
import React from "react";
import {makeStyles} from "@material-ui/styles";
import { formatDate } from '../../../../helpers/utils';
import DataIntegrityWarningsBadge from "../../dataIntegrity/shared/DataIntegrityWarningsBadge";
import RecordUpdatesBadge from "../../dataIntegrity/shared/RecordUpdatesBadge";
const useStyles = makeStyles((theme) => ({
  cardDataBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: '#fff',
    marginBottom: '15px',
    padding: '15px 22px',
    borderRadius: '3px',
  },
  cardDataBoxTitle: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#BEBEBE',
  },
  cardDataBoxSubtitle: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#000',
  },
  researcherName: {
    color: '#1E69E5',
  },
  photoContainer: {
    display: 'flex',
  },
  contactPhotoActionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  contactPhoto: {
    width: '35px',
    height: '35px',
  },
}));
const ContactHeader = (props) => {
  const classes = useStyles();
  const {
    contact, handleChangeFileInput, handleRemovePhoto, diCurrentCount, diTotalUniqueCount, fetchingDiWarnings,
    updatesAllTimeCount, updatesLast30DaysCount, fetchingUpdateCounts,
  } = props;

  return (
    <div className={classes.cardDataBox}>
      <div>
        <span className={classes.photoContainer}>
          <img src={contact.photoPreview} className={classes.contactPhoto} />

          <div className={classes.contactPhotoActionsContainer}>
            {contact.photoPreview != '' ? <Link className={classes.removePhotoLink} onClick={handleRemovePhoto}>Remove photo</Link> : ''}
            <input type='file' name='photo' onChange={handleChangeFileInput}/>
          </div>
        </span>
      </div>
      <div>
        <Typography variant="h5" className={ classes.cardDataBoxTitle }>
          Type
        </Typography>
        <span className={classes.cardDataBoxSubtitle}>
         {contact.entityType}
        </span>
      </div>
      <div>
        <Typography variant="h5" className={ classes.cardDataBoxTitle }>
          Created
        </Typography>
        <span className={classes.cardDataBoxSubtitle}>
          {contact.createdAt ? formatDate(contact.createdAt) : ''}
        </span>
      </div>
      <div>
        <Typography variant="h5" className={classes.cardDataBoxTitle}>
          Last Edit
        </Typography>
        <span className={classes.cardDataBoxSubtitle}>
          {contact.lastEdited ? formatDate(contact.lastEdited) : ''}
        </span>
      </div>
      <div>
        <Typography variant="h5" className={classes.cardDataBoxTitle}>
          Last Reviewed
        </Typography>
        <span className={classes.cardDataBoxSubtitle}>
            {contact.lastReviewed ? formatDate(contact.lastReviewed) : ''}
        </span>
      </div>
      <div>
        <Typography variant="h5" className={classes.cardDataBoxTitle}>
          {contact.is_registered ? 'CRD' : 'Employer Id'}
        </Typography>
        <span className={classes.cardDataBoxSubtitle}>
          {contact.crdId}
        </span>
      </div>
      <div>
        <Typography variant="h5" className={classes.cardDataBoxTitle}>
          Researcher
        </Typography>
        <span className={`${classes.cardDataBoxSubtitle} ${classes.researcherName}`}>
        {contact.researcher}
        </span>
      </div>
      <DataIntegrityWarningsBadge
        currentCount={diCurrentCount}
        totalUniqueCount={diTotalUniqueCount}
        fetching={fetchingDiWarnings}
        titleClassName={classes.cardDataBoxTitle}
        subtitleClassName={classes.cardDataBoxSubtitle}
      />
      <RecordUpdatesBadge
        allTimeCount={updatesAllTimeCount}
        last30DaysCount={updatesLast30DaysCount}
        fetching={fetchingUpdateCounts}
        titleClassName={classes.cardDataBoxTitle}
        subtitleClassName={classes.cardDataBoxSubtitle}
      />
    </div>
  )
}

export default ContactHeader;